import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import * as config from '../Configuration/Config.js'
// import UserProfile from '../Configuration/UserProfile.js'

class AdminSecurityRoleProfile extends Component {
    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this)
        this.handleChangeDashboards = this.handleChangeDashboards.bind(this)
        this.handleChangeVisualizations = this.handleChangeVisualizations.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.fetchDashboardsList = this.fetchDashboardsList.bind(this)
        this.fetchVisualizationsList = this.fetchVisualizationsList.bind(this)

        this.state = {
            is_loaded: false,
            redirect_customers: false,
            customer_id: 0,
            role_id: null,
            role: null,
            visualizations: [],
            dashboards: []
        }
    }

    setRedirect() {
        this.setState({redirect_customers: true});
    }

    componentDidMount() {
        // const user_id = this.props.match.params.uid;
        const customer_id = this.props.match.params.cid;
        const id = this.props.match.params.id;

        if (!customer_id || !id) {
            this.setState({ is_loaded: true, role: null, customer_id: 0, id: null });
            return;
        }

        if (id === 'new') {
            const data = {
                id: id,
                customer_id: customer_id,
                role_name: '',
                visualizations: [],
                dashboards: []
            };

            this.fetchVisualizationsList(customer_id, id, data);
            return;
        }

        var that = this;
        const uri = config.getUriPath('securityroles/' + id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                    console.log(response);
                    throw new Error("Bad response from server");
                }

                return response.json();
          })
          .then(function(data) {
            //console.log(data);
            that.fetchVisualizationsList(customer_id, id, data);
        });
    }

    fetchVisualizationsList(customer_id, role_id, role) {
        var that = this;
        const uri = config.getUriPath('visualizations/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
            //console.log(data);
            that.fetchDashboardsList(customer_id, role_id, role, data);
          });
    }

    fetchDashboardsList(customer_id, role_id, role, vizList) {
        var that = this;
        const uri = config.getUriPath('dashboards/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
              //console.log(data);
              that.setState({ is_loaded: true, customer_id: customer_id, role_id: role_id, role: role, visualizations: vizList, dashboards: data });
          });
    }

    handleSave(event) {
        event.preventDefault();

        var that = this;
        const id = this.state.role_id;
        let uriId = '';
        let method = 'post';
        if (id !== "new") {
            uriId = '/' + id;
            method = 'put';
        }

        const uri = config.getUriPath('securityroles' + uriId);
        fetch(uri, {
            method: method,
            headers: config.ApiHeaders(),
            body: JSON.stringify(this.state.role)
        }).then(function(response) {
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleDelete(event) {
        event.preventDefault();

        var that = this;

        const uri = config.getUriPath('securityroles/' + this.state.role_id)
        fetch(uri, {
            method: 'delete',
            headers: config.ApiHeaders()
        }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleCancel(event) {
        event.preventDefault();

        this.setRedirect();        
    }

    handleChange(event) {
        let data = this.state.role;
        data[event.target.name] = event.target.value;
        this.setState({role: data});
    }

    handleChangeDashboards(e) {
        let role = this.state.role;
        if (e.target.checked) {
            role.dashboards.push(e.target.name);
        } else {
            role.dashboards = role.dashboards.filter(x => x !== e.target.name);
        }

        this.setState({role: role});
    }

    handleChangeVisualizations(e) {
        let role = this.state.role;
        if (e.target.checked) {
            role.visualizations.push(e.target.name);
        } else {
            role.visualizations = role.visualizations.filter(x => x !== e.target.name);
        }

        this.setState({role: role});
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div></div>
        }

        if (this.state.redirect_customers){
            return <Redirect to='/admin/customers' />
        }

        const {role_id, role, customer_id} = this.state;

        if (!role_id || customer_id === 0 || !role) {
            return <h1>No role selected</h1>
        }

        //const profile = new UserProfile();
        // const isAcumenAdmin = profile.IsAcumenAdmin();
        const title = (role_id === "new") ? "Create New Security Role" : "Edit Security Role: " + role.role_name
        return  <div>
                    <div className="center-div">
                        <h1>{title}</h1>
                    </div>
                    <br />
                    <div className="form-wrapper">
                    <form>
                    <div className="form-group">
                            <label htmlFor="customer_name">Role Name:</label>
                            <input type="text" onChange={this.handleChange} className="form-control" name="role_name" defaultValue={role.role_name}/>
                        </div>
                        <div className="row">
                            <div className="col-md-6 dashboard-roles role-checkboxes">
                                <h3>Dashboards</h3>
                                <div className="form-group">
                                    {this.state.dashboards.map((item) => {
                                        return (
                                            <div className="form-check" key={item.id}>
                                                <input className="form-check-input" type="checkbox" value="" name={item.id} id={item.id} onChange={this.handleChangeDashboards} />
                                                <label className="form-check-label" htmlFor={item.id}>{item.display_name}</label>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="col-md-6 dashboard-roles role-checkboxes">
                                <h3>Visualizations</h3>
                                <div className="form-group">
                                        {this.state.visualizations.map((item) => {
                                            return (
                                                <div className="form-check" key={item.id}>
                                                    <input className="form-check-input" type="checkbox" value="" name={item.id} id={item.id} onChange={this.handleChangeVisualizations}/>
                                                    <label className="form-check-label" htmlFor={item.id}>{item.display_name}</label>
                                                </div>
                                            )
                                        })}
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="centerAlign" colSpan="2">
                                <button onClick={this.handleSave} name="save" className="loginButton btn btn-primary">Save</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleDelete} name="delete" className={role_id === "new" ? "hidden" : "loginButton btn btn-danger"}>Delete</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleCancel} name="cancel" className="loginButton btn btn-info">Cancel</button>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
    }
}

export default AdminSecurityRoleProfile


// WEBPACK FOOTER //
// ./src/Components/AdminSecurityRoles/AdminSecurityRoleProfile.js